// Section anchor ids, shared between the header nav links and each section's
// own `id` attribute so the two can never drift out of sync.
export const SECTION_IDS = {
  home: "home",
  about: "about",
  story: "story",
  subscription: "subscription",
  menu: "menu",
  contact: "contact",
  enquiry: "enquiry",
};
